import { renderSentryMaskedText } from '@app/utils/monitoring';
import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  path: string;
  email: string;
}

export const EmailWithLinkCell = ({ path, email }: Props) => {
  const ref = React.useRef<HTMLDivElement>(null);

  return (
    <Link to={path} className="underline">
      <div ref={ref} className="relative z-interactiveTableItem max-w-52 truncate">
        <span className="body-2">{renderSentryMaskedText(email)}</span>
      </div>
    </Link>
  );
};
